import { PayloadAction } from "@reduxjs/toolkit";
import { apiCall } from "../../utils/apiCall";
import { put, all, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";
import { loginActions } from "./reducer";
import crypto from "crypto-js";

function* empresasWorker() {
  try {
    const res: AxiosResponse<Record<string, any>[]> = yield call(
      apiCall,
      {
        url: "/empresas",
        method: "GET",
      }
    );
    console.log("empresas retornadas", res.data);
    yield put(loginActions.empresasSuccess(res.data));
  } catch (error) {
    yield put(
      loginActions.empresasError(
        `Erro ao carregar empresas: ${JSON.stringify(error)}`
      )
    );
  }
}

function* loginWorker({
  payload,
}: PayloadAction<{ usuario: string; senha: string; empresa: string }>) {
  try {
    const dataToSend = {
      usuario: payload.usuario,
      password: payload.senha,
      device_name: "SAERP-Expedicao",
      cia_ukey: payload.empresa,
    };
    // dataToSend.senha = crypto.SHA512(payload.senha).toString(crypto.enc.Base64);
    console.log("sending data", dataToSend);
    const res: AxiosResponse<any> = yield call(apiCall, {
      url: "/tokens/create",
      method: "POST",
      data: {
        ...dataToSend,
      },
    });
    console.log("login retornada", res.data);
    if (res.data?.error) {
      yield put(loginActions.loginError(res.data?.error));
    } else {
      yield put(loginActions.loginSuccess(res.data));
    }
  } catch (error) {
    yield put(
      loginActions.loginError(`Erro ao logar: ${JSON.stringify(error)}`)
    );
  }
}

export function* loginSaga() {
  yield all([
    takeLatest("login/empresasRequest", empresasWorker),
    takeLatest("login/loginRequest", loginWorker),
  ]);
}
